// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Blp4AhncEzPN2TeLNkvJ {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}
.Blp4AhncEzPN2TeLNkvJ a {
  text-decoration: underline;
  cursor: pointer;
}
.Blp4AhncEzPN2TeLNkvJ a:hover {
  text-decoration: underline;
}

.ENZHn0Ir7bfBIQybZ7Nr {
  text-align: center;
  max-width: 200px;
}

.l73XYjqXqX1Y1J5rvQrQ {
  line-height: 18px;
  max-width: 200px;
  text-align: center;
}

.sKuXgo3pmRxCIrBMgzZC {
  cursor: pointer;
  padding-left: 4px;
}

.SEJKROQk08zbrvNvgYv0 a {
  text-decoration: underline;
  cursor: pointer;
}
.SEJKROQk08zbrvNvgYv0 a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/header/threat-info/threat-info.module.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;AAAF;AAEE;EACE,0BAAA;EACA,eAAA;AAAJ;AAEI;EACE,0BAAA;AAAN;;AAKA;EACE,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;AAFF;;AAME;EACE,0BAAA;EACA,eAAA;AAHJ;AAKI;EACE,0BAAA;AAHN","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.threat_info {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n\n  a {\n    text-decoration: underline;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.threat_info_name {\n  text-align: center;\n  max-width: 200px;\n}\n\n.threat_info_actor {\n  line-height: 18px;\n  max-width: 200px;\n  text-align: center;\n}\n\n.more_actors {\n  cursor: pointer;\n  padding-left: 4px;\n}\n\n.actor_tooltip {\n  a {\n    text-decoration: underline;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"threat_info": `Blp4AhncEzPN2TeLNkvJ`,
	"threat_info_name": `ENZHn0Ir7bfBIQybZ7Nr`,
	"threat_info_actor": `l73XYjqXqX1Y1J5rvQrQ`,
	"more_actors": `sKuXgo3pmRxCIrBMgzZC`,
	"actor_tooltip": `SEJKROQk08zbrvNvgYv0`
};
export default ___CSS_LOADER_EXPORT___;
